export default __webpack_public_path__ + "static/media/source.f1d27682.PNG";